import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import CardBio from "./CardBio";
import CardParents from "./CardParents";
import { Documents } from "../../../../StudentNewComming/Documents";
import { Accordion, Button, useAccordionToggle, Card } from "react-bootstrap";
import { Error404 } from "../../../../../Library/LoaderPage";
import CardAddress from "./CardAddress";
import { CalculatePersentaseProfile } from "../../_core/_core";
import { GET_ENROLLMENT_PROCESS } from "../../../../StudentNewComming/APIS";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { GET_ENROLLMENT_PROCESS_BY_ID } from "../../API";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];


export function StdBiodata({ student }) {
  const [fams, setFams] = useState(0);
  const [docStatus, setDocStatus] = useState(0);
  const total_calculate = useMemo(() => {
    let computedData = [];
    if (student) {
      computedData = CalculatePersentaseProfile(student);
      const find_fams_data = computedData?.incomplete_fields?.family || [];
      if (find_fams_data && Object.values(find_fams_data).length > 0) {
        const father_data =
          find_fams_data.filter((item) => item.includes("FATHER")) || [];
        const father_missing = find_fams_data.find((item) =>
          item.includes("FATHER_MISSING")
        )
          ? 4
          : Object.values(father_data).length;

        const mother_data =
          find_fams_data.filter((item) => item.includes("MOTHER")) || [];
        const mother_missing = find_fams_data.find((item) =>
          item.includes("MOTHER_MISSING")
        )
          ? 4
          : Object.values(mother_data).length;

        const total_missing = father_missing + mother_missing;
        console.log("-----");
        console.log(father_missing, mother_missing);
        console.log("-----");
        setFams(total_missing);
      } else {
        setFams(0);
      }
    }
    return computedData;
  }, [student, fams]);

  const [enrollment, setEnrollment] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const ReloadEnrollment = async () => {
    setEnrollment({ loading: true, data: [], message: "" });
    const results = await GET_ENROLLMENT_PROCESS({
      candidate_id: student.studentid,
    });
    if (results.data && Object.values(results.data).length > 0) {
      const find_row = results.data.find(
        (item) => item.candidate_id === student.studentid
      );
      const get_candidate_data = await GET_ENROLLMENT_PROCESS_BY_ID({ enroll_id: find_row?.id });
      // console.log(get_candidate_data);
      setDocStatus(find_row?.doc_status || 0);
      setEnrollment(get_candidate_data);
    } else {
      setEnrollment(results);
    }
  };

  useEffect(() => {
    if (student) {
      ReloadEnrollment();
    }
  }, [student]);

  const ReloadData = () => {
    setInterval(() => {
      window.location.reload();
    }, 2000);
  }

  if (student) {
    return (
      <div id="biodata-std">
        <Accordion defaultActiveKey="0">
          <Card>
            <Card.Header>
              <CustomToggle eventKey="0">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="mb-0 text-left">1. Personal Information</h2>
                  <BadgeComplete total_complete={12} total_incomplete={Object(total_calculate?.incomplete_fields?.bio).length} />
                </div>
              </CustomToggle>
            </Card.Header>
          </Card>
          <Accordion.Collapse eventKey="0">
            <CardBio data={student} ReloadDataStd={ReloadData} enrollment={enrollment.data} />
          </Accordion.Collapse>

          <Card>
            <Card.Header>
              <CustomToggle eventKey="1">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="mb-0 text-left">2. Contact Addresses</h2>
                  <BadgeComplete total_complete={7} total_incomplete={Object(total_calculate?.incomplete_fields?.address).length} />
                </div>
              </CustomToggle>
            </Card.Header>
          </Card>
          <Accordion.Collapse eventKey="1">
            <CardAddress student={student} ReloadDataStd={ReloadData} enrollment={enrollment.data} />
          </Accordion.Collapse>

          <Card>
            <Card.Header>
              <CustomToggle eventKey="2">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="mb-0 text-left">3. Parent Information</h2>
                  <BadgeComplete total_complete={9} total_incomplete={fams} />
                </div>
              </CustomToggle>
            </Card.Header>
          </Card>
          <Accordion.Collapse eventKey="2">
            <CardParents student={student} ReloadDataStd={ReloadData} enrollment={enrollment.data} />
          </Accordion.Collapse>

          {(AuthDecode.TypeCK !== "production") && (
            <Card>
              <Card.Header>
                <CustomToggle eventKey="3">
                  <h2 className="mb-0 text-left"></h2>
                  <div className="d-flex justify-content-between align-items-center">
                    <h2 className="mb-0 text-left">4. Document Requirements</h2>

                    {enrollment.loading ? (
                      <LoadingBtn />
                    ) : (
                      <div className={`badge badge-${docStatus === 1 ? 'primary' : 'warning'} pb-2 px-5`}>
                        <span className="mr-2 font-weight-bold">
                          {docStatus === 1 ? "Completed" : "Uncompleted"}
                        </span>
                      </div>
                    )}
                  </div>
                </CustomToggle>
              </Card.Header>
            </Card>
          )}
          <Accordion.Collapse eventKey="3">
            {enrollment.loading ? (
              <LoadingBtn />
            ) : (
              <Documents student={student} />
            )}
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  } else {
    return <Error404 />;
  }
}

const CustomToggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionToggle(eventKey);

  return (
    <Button
      type="button"
      onClick={decoratedOnClick}
      className="btn-light w-100"
    >
      {children}
    </Button>
  );
};

const BadgeComplete = ({ total_incomplete, total_complete }) => {
  if (total_incomplete !== 0) {
    return (
      <div className="badge badge-warning pb-2 px-5">
        <span className="mr-2 font-weight-bold">Incomplete:</span>
        <span className="font-weight-bold">
          {`${total_incomplete}/${total_complete}`}
        </span>
      </div>
    );
  } else {
    return <div className="badge badge-primary pb-2 px-5"><span className="font-weight-bold">Completed</span></div>;
  }
};
